import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después del pago recibirás un enlace de descarga. Es un PDF que podés leer en cualquier dispositivo.'
}, {
  question: '¿Sirve si mi pareja no quiere participar?',
  answer: 'Sí. El material incluye una sección para aplicar cambios unilaterales que generan un impacto positivo en el vínculo.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. Pagás una sola vez y tenés acceso de por vida al material. Sin suscripciones ni costos ocultos.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Si el contenido no te aporta valor, tenés 7 días para pedir la devolución total. Sin preguntas.'
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-114">
      <div className="max-w-3xl mx-auto px-6" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-116">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-16 text-center font-serif" data-id="element-117">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-118">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className="bg-[#1A0050] rounded-[20px] overflow-hidden border border-[#7C3AED]/30 shadow-sm" data-id="element-119">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#7C3AED]/10 transition-colors" data-id="element-120">
                  <span className="text-lg font-semibold text-white pr-4 font-sans" data-id="element-121">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-122">
                    <ChevronDownIcon className="w-5 h-5 text-[#7C3AED] flex-shrink-0" data-id="element-123" />
                  </motion.div>
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-124">
                  <div className="px-8 pb-6 text-[#C4B5FD] leading-relaxed font-sans" data-id="element-125">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}